import React from 'react';


class ShiftActivity extends React.Component {

    render () {
        return (
            <div className={"shift-activity" + (this.props.isActive ? " active" : "")}>
                <div className="activity-days">
                    <div className="activity-day">
                        <div className="activity-day-header">
                            <h3 className="activity-day-title">Today</h3>
                        </div>

                        <div className="activity-event event-apply">
                            <span className="activity-event-time">12:36</span>
                            <span className="activity-event-message"><b>Gregory C.</b> applied for the shift</span>
                        </div>

                        <div className="activity-event event-decline">
                            <span className="activity-event-time">12:36</span>
                            <span className="activity-event-message"><b>You</b> declined <b>Sara K.</b>’s application</span>
                        </div>

                        <div className="activity-event event-update">
                            <span className="activity-event-time">5:36</span>
                            <span className="activity-event-message"><b>You</b> updated the description</span>
                        </div>

                    </div>
                    <div className="activity-day">
                        <div className="activity-day-header">
                            <h3 className="activity-day-title">YESTERDAY</h3>
                        </div>

                        <div className="activity-event event-apply">
                            <span className="activity-event-time">12:36</span>
                            <span className="activity-event-message"><b>Sara K</b>. applied for the shift</span>
                        </div>

                        <div className="activity-event event-create">
                            <span className="activity-event-time">12:36</span>
                            <span className="activity-event-message"><b>You</b> created the shift</span>
                        </div>

                    </div>

                    <button className="btn btn-small btn-bordered btn-load-more">Load more activity</button>
                </div>
            </div>
        );
    }
}

export default ShiftActivity;



/** WEBPACK FOOTER **
 ** ./app/src/components/ShiftActivity.js
 **/